// console.log('this is a text');
// $(document).ready(function(){
//   $('.product-class-section.our-products-slider .products-slider').slick({
//     slidesToShow: 3.5,   
//     slidesToScroll: 1,
//     infinite: false,
//     autoplay: true,
//     autoplaySpeed: 1000,
//     arrows: false,
//     dots: false,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: { slidesToShow: 2.5 }
//       },
//       {
//         breakpoint: 768,
//         settings: { slidesToShow: 1.5 }
//       },
//       {
//         breakpoint: 480,
//         settings: { slidesToShow: 1.1 }
//       }
//     ]
//   });
// });

// $(document).ready(function(){
//   $('.product-class-section.our-products-slider .products-slider-1, .product-class-section.our-products-slider .products-slider-2, .product-class-section.our-products-slider .products-slider-3, .product-class-section.our-products-slider .products-slider-4, .product-class-section.our-products-slider .products-slider-5').slick({
//     slidesToShow: 2.5,   
//     slidesToScroll: 1,
//     infinite: false,
//     autoplay: true,
//     autoplaySpeed: 1000,
//     arrows: false,
//     dots: false,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: { slidesToShow: 2.5 }
//       },
//       {
//         breakpoint: 768,
//         settings: { slidesToShow: 1.5 }
//       },
//       {
//         breakpoint: 480,
//         settings: { slidesToShow: 1 }
//       }
//     ]
//   });
// });

$(document).ready(function(){
  $('.testimonial-slider-section .testimonial-slider').slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false
  });
});


//  $(document).on("click", "#load-more-recipes", function() {
//     var button = $(this);
//     var page = button.data("page");
//     var blogHandle = button.data("blog");
//     var limit = button.data("limit");

//     $.ajax({
//       url: "/blogs/" + blogHandle + "?page=" + page ,
//       // url: "/pages/recipes",
//       type: "GET",
//       success: function(data) {
//         var newPosts = $(data).find(".custom-blog-grid .recipe-card"); 
//         if (newPosts.length) {
//           // append only articles, not the whole grid
//           $("#recipes-grid").append(newPosts);
//           button.data("page", page + 1);
//         } else {
//           button.hide();
//         }
//       }
//     });
//   });

$(document).on("click", "#load-more-recipes", function () {
  var button = $(this);
  var page = button.data("page");
  var blogHandle = button.data("blog");
  var limit = button.data("limit");

  $.ajax({
    url: "/blogs/" + blogHandle + "?page=" + page,
    type: "GET",
    success: function (data) {
      // Select from the default blog template’s article wrapper
      var newPosts = $(data).find(".recipes-grid .recipe-card");

      if (newPosts.length) {
        $("#recipes-grid").append(newPosts);
        button.data("page", page + 1);
      } else {
        button.hide();
      }
    },
  });
});



// $(document).ready(function() {
//     $('.product-card-add-to-cart-form').on('submit', function(event) {
//         event.preventDefault();
//         var $form = $(this);
//         var formData = $form.serialize();
//         $.ajax({
//             type: 'POST',
//             url: '/cart/add',
//             data: formData,
//             dataType: 'json', 
            
//             success: function(data) {
//                  let $cartDrawer = $('cart-drawer.drawer');

//                  $cartDrawer.trigger('click'); 
//                  $cartDrawer.addClass('animate active');
                
//             },
//             error: function(xhr, status, error) {
//                 console.error('Error adding product to cart:', xhr.responseText);
                
//             }
//         });
//     });
// });


$(document).ready(function(){
  
  $('.filter-toggle').on('click', function(){
      $('.recipes-filter').slideToggle(300);
      setTimeout(function(){
          $('html, body').animate({
              scrollTop: $('.custom-blog-grid').offset().top - 180
          }, 600);
      }, 50);
    });

    $('.filter-btn').on('click', function(){
      $('.filter-btn').removeClass('active');
      $(this).addClass('active');

      let filter = $(this).attr('data-filter').toLowerCase();
      // console.log('filter', filter);
      $('.recipes-grid .recipe-card').each(function(){
        let tags = $(this).attr('data-tags').toLowerCase();
        // console.log('tags', tags);
        if(filter === 'all' || tags.includes(filter)){
          $(this).fadeIn(300);
        } else {
          $(this).fadeOut(300);
        }
      });
      

    });
  });